import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext(null);

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

/**
 * Light-only theme. The toggle still exists as a no-op so legacy
 * code that calls `toggleTheme()` doesn't break, but `isDark` is
 * permanently false and no `.dark` class is applied to <html>.
 */
export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.add('light');
    localStorage.setItem('app-theme', 'light');
  }, []);

  const value = {
    isDark: false,
    setIsDark: () => {},
    toggleTheme: () => {},
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
